import axios from "@/axios/axios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    loadXML(context, obj) {
      console.log(obj);
      return axios
        .get(obj.link, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          if (response.status == 200) {
            const fileName = obj.name ? obj.name : "검색이력.xlsx";
            console.log(fileName);
            const url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    getAll() {
      return axios
        .get("/api/survey/data/all")
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    uploadSurvey(context, params) {
      var formData = new FormData();
      formData.append("file1", params.file1);
      formData.append("file2", params.file2);

      return axios
        .post(
          "/api/survey/data/upload?title=" +
            params.title +
            "&title2=" +
            params.title,
          formData
        )
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },

    deleteSurvey(context, idx) {
      return axios
        .delete("/api/survey/data/delete?idx=" + idx)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
  },
};
